import { useState } from "react";
import { useParams } from "react-router-dom";
import API_URL from '../../../utils/api';
import "../../Dashboard/View/Dashboard.css";
function EvalForm({ phase, pairId, onDone }) {
  const [pleasantness, setPleasantness] = useState(4);
  const [intensity, setIntensity] = useState(4);
  const [connection, setConnection] = useState(4);
  const [durationMinutes, setDuration] = useState(10);
  const [notes, setNotes] = useState("");
  async function submit() {
    await fetch(`${API_URL}/api/pairs/${pairId}/eval/${phase}`, {
      method: "POST",
      headers: {"Content-Type":"application/json"},
      body: JSON.stringify({ pleasantness, intensity, connection, duration_minutes: durationMinutes, notes })
    });
    onDone?.();
  }
  return (
    <div className="auth-form">
      <label>Pleasantness (1–7)
        <input className="dashboard-input" type="number" min="1" max="7" value={pleasantness} onChange={e=>setPleasantness(+e.target.value)} />
      </label>
      <label>Intensity (1–7)
        <input className="dashboard-input" type="number" min="1" max="7" value={intensity} onChange={e=>setIntensity(+e.target.value)} />
      </label>
      <label>Connection (1–7)
        <input className="dashboard-input" type="number" min="1" max="7" value={connection} onChange={e=>setConnection(+e.target.value)} />
      </label>
      <label>Duration (minutes)
        <input className="dashboard-input" type="number" value={durationMinutes} onChange={e=>setDuration(+e.target.value)} />
      </label>
      <label>Notes
        <textarea className="dashboard-input" value={notes} onChange={e=>setNotes(e.target.value)} />
      </label>
      <button className="create-session-btn" onClick={submit}>Submit {phase}</button>
    </div>
  );
}
export default function Breakout() {
  const { pairId } = useParams();
  const [phase, setPhase] = useState("pre");
  return (
    <div className="dashboard-root">
      <div className="dashboard-main">
        <div className="session-card" style={{ maxWidth: 640 }}>
          <h3>Breakout</h3>
          {phase === "pre" && <EvalForm phase="pre" pairId={pairId} onDone={() => setPhase("chat")} />}
          {phase === "chat" && (
            <>
              <p>Chat in progress…</p>
              <button className="join-session-btn" onClick={() => setPhase("post")}>Finish Chat</button>
            </>
          )}
          {phase === "post" && <EvalForm phase="post" pairId={pairId} onDone={() => setPhase("done")} />}
          {phase === "done" && <p>Thanks! You can leave this room.</p>}
          <div style={{ marginTop: 12, fontSize: 12, color: "#777" }}>Pair ID: {pairId}</div>
        </div>
      </div>
    </div>
  );
}
